module.exports = __webpack_public_path__ + "img/button_heart2.fa898ade.svg";